(() => {
  const syncProductFormMode = () => {
    const main = document.getElementById('MainContent');
    const isProduct = main?.dataset.template === 'product';
    const isNativeConfigurator = main?.dataset.templateSuffix === 'configurator';
    const hasTeeInBlue = Boolean(document.getElementById('tee-artwork-form'));

    document.body.classList.toggle(
      'teeinblue-enabled',
      Boolean(isProduct && hasTeeInBlue && !isNativeConfigurator)
    );
  };

  const observeProductForms = () => {
    syncProductFormMode();
    const observer = new MutationObserver(syncProductFormMode);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProductForms, { once: true });
  } else {
    observeProductForms();
  }
})();
